import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrapper, StyledHeaderSection, StyledHeader, StyledSubheader } from './ProductBundleMessageStyles';

var ProductBundleMessage = function ProductBundleMessage(props) {
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      StyledHeaderSection,
      null,
      props.bundleHeader && React.createElement(
        StyledHeader,
        null,
        props.bundleHeader.value
      ),
      props.bundleMessage && React.createElement(
        StyledSubheader,
        null,
        props.bundleMessage.value
      )
    )
  );
};

ProductBundleMessage.propTypes = {
  bundleHeader: PropTypes.object,
  bundleMessage: PropTypes.object
};

export default ProductBundleMessage;